import React, { useContext, useEffect, useRef } from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import styled from 'styled-components'
import { gsap } from 'gsap'
import { useLocation } from 'react-use'

import { GatsbyContext } from '../../context'
import Hamburger from './Hamburger'
import bgWhite from '../../images/full_bg.jpg'
import bgArrow from '../../images/full_arrow.png'
import BgBlue from '../../images/bgBlue.inline.svg'
import pageLinks from '../../constants/links-sub'
import { Link } from 'gatsby'

// import BlockSvg from './BlockSvg'

const FullScreenWrap = styled.div`
  position: absolute;
  top: 0;
  /* left: ${(props) => (props.status ? 0 : '120%')}; */
  left: 0;
  width: 100%;
  height: 100vh;
  transition: all 2s ease-out;
  pointer-events: ${(props) => (props.status ? 'all' : 'none')};
  opacity: ${(props) => (props.status ? 1 : 0)};
  .container {
    width: 100%;
    height: 100vh;
    position: relative;
    .hamburger {
      position: absolute;
      top: 0px;
      right: 32px;
      display: flex;
      opacity: 0;
      z-index: 9999;
    }
    .bg-abs {
      position: absolute;
      top: 0;
      left: 200%;
      width: 100%;
      height: 100vh;
      opacity: 0;
      z-index: 50;
    }
    .bg-skew {
      transform-origin: top right;
      transform: skewX(-30deg);
    }
    .bg-one {
      background-color: ${(props) => props.theme.colors.primary};
      z-index: 200;
      opacity: 0;
    }
    .bg-two {
      transform: skewX(-30deg);
      background-color: ${(props) => props.theme.colors.secondary};
      z-index: 199;
      opacity: 0;
    }
    .bg-white {
      width: 200vw;
      background-color: #fff;
      transform-origin: top left;
      opacity: 0;
    }
    .bg-image {
      z-index: 100;
      background-image: url(${bgWhite});
      background-repeat: no-repeat;
      background-position: right bottom;
      opacity: 0;
    }
    .bg-arrow {
      z-index: 102;
      background-image: url(${bgArrow});
      background-repeat: no-repeat;
      background-position: right bottom;
      opacity: 0;
    }
    .bg-svg {
      z-index: 101;
      opacity: 0;
      .blue-inline {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 827px;
        height: 620px;
        z-index: -1;
      }
      .full-logo {
        width: 116px;
        position: absolute;
        top: 195px;
        left: 0;
        opacity: 0;
        transform: scale(8);
      }
    }
    .bg-menu {
      z-index: 201;
      opacity: 0;
      .full-menu {
        width: 100%;
        min-height: 200px;
        position: absolute;
        top: 380px;
        display: flex;
        left: 0;
        &__item {
          display: flex;
          width: 140px;
          flex-direction: column;
          position: relative;
          &__parent {
            font-size: 2rem;
            opacity: 0;
            transform: translateY(-200px) scale(8);
            a,
            strong {
              transition: 0.3s ease-in-out;
              display: flex;
              flex-direction: column;
              font-weight: bold;

              span {
                font-size: 1.2rem;
                padding-top: 5px;
                font-family: 'Poppins', sans-serif;
                color: #00000030;
                text-transform: uppercase;
              }
            }
            a:hover {
              color: ${(props) => props.theme.colors.primary};
              /* transform: translateY(20px); */
              font-size: 3rem;
            }
          }
          &__child {
            opacity: 0;
            font-size: 1.4rem;
            margin-top: 20px;
            transform: translateY(-200px) scale(8);
            a {
              color: #00000060;
              transition: 0.3s ease-in-out;
              display: flex;
              flex-direction: column;
              font-weight: bold;
            }
            a:hover {
              color: ${(props) => props.theme.colors.primary};
              /* transform: translateY(20px); */
              transform: scale(1.5);
              transform-origin: left;
            }
          }
        }
      }
      .full-slogan {
        width: 252px;
        position: absolute;
        bottom: 255px;
        left: 0;
        opacity: 0;
        transform: scale(8);
      }
    }
  }
`

const FullScreen = (props) => {
  const { isFullscreenOpen, handleFullscreen, hideFullscreen } =
    useContext(GatsbyContext)
  const el = useRef()

  const q = gsap.utils.selector(el)
  const tl = useRef()
  const location = useLocation()
  // const stopColor = '#1166B6'
  // const blueBoxAnimation = () => {
  //   gsap.to(q('#pathLeft'), {
  //     fill: '#166ebc',
  //     repeat: -1,
  //     yoyo: true,
  //     duration: 3,
  //     repeatDelay: 0
  //   })
  //   gsap.to(q('#pathRight'), {
  //     fill: '#47c0f5',
  //     repeat: -1,
  //     yoyo: true,
  //     duration: 3,
  //     repeatDelay: 0
  //   })
  //   gsap.to(q('#pathUp'), {
  //     fill: '#2587cd',
  //     repeat: -1,
  //     yoyo: true,
  //     duration: 3,
  //     repeatDelay: 0
  //   })
  // }

  useEffect(() => {
    // blueBoxAnimation()
    tl.current = gsap
      .timeline()
      .to(
        q('.bg-one'),
        {
          left: 'calc(-100% + 100px)',
          opacity: 1,
          duration: 0.3
        },
        '-=0.1'
      )
      .to(
        q('.bg-two'),
        {
          left: 'calc(-100% + 200px)',
          duration: 0.3,
          opacity: 1
        },
        '-=0.1'
      )
      .to(
        q('.bg-white'),
        {
          left: '0',
          duration: 0.3,
          opacity: 1
        },
        '-=0.3'
      )
      .to(
        q('.bg-image'),
        {
          left: '0',
          duration: 0.2,
          opacity: 1
        },
        '-=0.4'
      )
      .to(
        q('.bg-arrow'),
        {
          left: '0',
          duration: 0.2,
          opacity: 1
        },
        '-=0.3'
      )
      .to(
        q('.bg-svg'),
        {
          left: '0',
          duration: 0.2,
          opacity: 1
        },
        '-=0.2'
      )
      .to(q('.full-logo'), {
        left: 225,
        scale: 1,
        duration: 0.2,
        opacity: 1
      })
      .to(
        q('.bg-menu'),
        {
          left: 225,
          duration: 0.1,
          opacity: 1
        },
        '-=1'
      )
      .to(q('.full-menu__item__parent'), {
        y: 0,
        duration: 0.1,
        scale: 1,
        opacity: 1,
        stagger: 0.1
      })
      .to(
        q('.full-menu__item__child'),
        {
          y: 0,
          duration: 0.1,
          scale: 1,
          opacity: 1,
          stagger: 0.1
        },
        '-=0.4'
      )
      .to(
        q('.full-slogan'),
        {
          left: 0,
          scale: 1,
          duration: 0.3,
          opacity: 1
        },
        '-=0.2'
      )
      .to(
        q('.hamburger'),
        {
          opacity: 1,
          duration: 0.3,
          top: 22
        },
        '-=1'
      )
  }, [])
  useEffect(() => {
    // toggle the direction of our timeline
    tl.current.timeScale(1.2).reversed(!isFullscreenOpen)
  }, [isFullscreenOpen])
  useEffect(() => {
    hideFullscreen()
  }, [location.pathname])
  return (
    <FullScreenWrap status={isFullscreenOpen || false}>
      <div className="container" ref={el}>
        <div className="bg-one bg-abs bg-skew" />
        <div className="bg-two bg-abs bg-skew" />
        <div className="bg-white bg-abs bg-skew" />
        <div className="bg-image bg-abs" />
        <div className="bg-arrow bg-abs" />
        <div className="bg-svg bg-abs">
          {/* <BgBlue></BgBlue> */}

          <div className="blue-inline">
            <StaticImage
              src="../../images/bgBlue.inline.svg"
              alt="A dinosaur"
              placeholder="blurred"
              layout="fixed"
              width={827}
              height={620}
            />
          </div>
          <div className="full-logo">
            <StaticImage
              src="../../images/logo_JinJiang.svg"
              alt="A dinosaur"
              placeholder="blurred"
              layout="fixed"
              width={116}
            />
          </div>
        </div>
        <div className="bg-menu bg-abs">
          <div className="full-menu">
            {pageLinks.map((menu) => (
              <div className="full-menu__item" key={menu.id}>
                <div className="full-menu__item__parent">
                  {menu.sub ? (
                    <strong>
                      {menu.name}
                      <span>{menu.eng}</span>
                    </strong>
                  ) : (
                    <Link to={menu.slug}>
                      {menu.name}
                      <span>{menu.eng}</span>
                    </Link>
                  )}
                </div>
                {menu.sub
                  ? menu.sub.map((item) => (
                      <div className="full-menu__item__child" key={item.id}>
                        <Link to={item.slug}>{item.name}</Link>
                      </div>
                    ))
                  : ''}
              </div>
            ))}
          </div>
          <div className="full-slogan">
            <StaticImage
              src="../../images/slogan_jinjiang.svg"
              alt="A dinosaur"
              placeholder="blurred"
              layout="fixed"
              width={252}
            />
          </div>
        </div>
        <div className="hamburger">
          <Hamburger
            handleStatus={handleFullscreen}
            status={isFullscreenOpen}
            color={'#000'}
          />
        </div>
      </div>
    </FullScreenWrap>
  )
}

export default FullScreen
